// removed by extract-text-webpack-plugin
module.exports = {"HomePage":"HomePage_HomePage__2_0i","Video":"HomePage_Video__2Cbf","Description":"HomePage_Description__UcG8","Buttons":"HomePage_Buttons__McJ0","Link":"HomePage_Link__3k7E","ButtonLeft":"HomePage_ButtonLeft__eqtQ","ButtonRight":"HomePage_ButtonRight__1au6","Section":"HomePage_Section__SlhY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/HomePage/HomePage.scss
// module id = 312
// module chunks = 0